import "./StaticText.scss"
const StaticText = () => {
  return (
  <section className="browse-subjects">
  <div className="container text-right">
   <div className="browse-title ">
     <h2 >Browse all our subjects</h2>
   </div>

    <p className="browse-text">
      Stop switching between multiple platforms for different subjects. DoubtQ brings complete academic support in one place, covering engineering and beyond. Get help across 100+ subjects from experienced tutors who understand your needs, solve complex problems, and save your time with reliable, all-in-one academic assistance.
    </p>

    {/* <p className="browse-text">
      We provide solutions to a wide range of problems faced by the students during their engineering courses.
      We have 1000+ experienced tutors having expertise in more than 100 subjects individually.
    </p> */}
  </div>
</section>
  )
}   

export default StaticText